import Skeleton from "../../common/Skeleton";

const CategorizationAmtSkeleton = () => {
  return (
    <div className="relative flex items-center border border-[#d0d4e4] rounded-md dark:border-0 bg-white dark:bg-[#121419] w-full shadow-[5px_1px_5px_rgba(0,0,0,0.09)] px-4 py-2 min-h-[80px]">
      <div className="absolute -left-2 top-1/2 -translate-y-1/2 bg-white dark:bg-[#121419] p-2 rounded-full shadow z-20 border border-gray-200 dark:border-gray-700 w-8 h-8 flex justify-center items-center">
        <Skeleton className="w-4 h-4 rounded-full" />
      </div>

      <div className="flex-1 flex overflow-x-auto gap-4 hide-scrollbar">
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            className="min-w-[200px] w-[200px] flex-shrink-0 rounded-lg px-3 py-2 border flex flex-col justify-center bg-gray-100/30 dark:bg-gray-800/30 border-gray-200 dark:border-gray-700/50 backdrop-blur-md"
          >
            <Skeleton className="w-24 h-4 rounded mb-1" />
            <Skeleton className="w-16 h-6 rounded" />
          </div>
        ))}
      </div>

      <div className="absolute -right-2 top-1/2 -translate-y-1/2 bg-white dark:bg-[#121419] p-2 rounded-full shadow z-20 border border-gray-200 dark:border-gray-700 w-8 h-8 flex justify-center items-center">
        <Skeleton className="w-4 h-4 rounded-full" />
      </div>
    </div>
  );
};

export default CategorizationAmtSkeleton;
